import { pxToRem } from '@/shared/styles/themes'
import { Paper, Popover, styled } from '@mui/material'

export const StyledPopper = styled(Popover)`
  border: none;

  & .MuiPopover-paper {
    &:after {
      display: block;
      content: '';
      position: absolute;
      z-index: 100;
      background-color: ${props => props.theme.palette.background.default};
      width: 12px;
      height: 12px;
      transform: rotate(45deg);
      top: -6px;
      right: 64px;
      border-top: 1px solid ${props => props.theme.palette.divider};
      border-left: 1px solid ${props => props.theme.palette.divider};
      z-index: 0;
  
      ${(props) => props.theme.breakpoints.up(400)} {
        right: 12px;
      }
    }
  }
`

export const StyledPaper = styled(Paper)`
  position: relative;
  justify-content: center;
  box-shadow: 0px ${pxToRem(4)} ${pxToRem(25)} rgba(0, 0, 0, 0.15);
  border-radius: ${pxToRem(15)};
  border: 1px solid ${props => props.theme.palette.divider};
  max-height: 80vh;
  overflow-y: scroll;

  &::-webkit-scrollbar { 
    width: 0px; 
  } 

  &::-moz-scrollbar { 
    width: 0px; 
  }
`
